import * as React from "react";
import { useState, useEffect } from "react";
import { Button, KIND } from "baseui/button";
import { Input} from "baseui/input";
import { useStyletron } from "baseui";
import { LabelLarge } from "baseui/typography";
import { MainContainer, InputContainer } from "./LoginStyles";
import { AuthForm, StyledLink } from './AuthForm'; // Import AuthForm
function ConfirmationCodeView(props) {
  const [css, theme] = useStyletron();
    const [code, setCode] = useState(null);
 const [isLoading, setIsLoading] = useState(props.isLoading);
  const [error, setError] = useState(props.error);

  useEffect(() => {
    setError(props.error);
    setIsLoading(props.isLoading);
    }, [props.error, props.isLoading]);

  const handleConfirmCode = () => {
    if(!code){
        setError("Please enter code")
        return
    };
    props.onSubmitConfirmationCode(code)
  };
  return (
    <AuthForm error={error} isLoading={props.isLoading}>
            <div className={css({ marginBottom: theme.sizing.scale600 })}>
              <LabelLarge
                className={css({ marginBottom: theme.sizing.scale300 })}
              >
                Confirm Your Code
              </LabelLarge>
              <Input
                type="number"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="Enter Confirmation Code"
              />
            </div>

            <div className={css({ marginBottom: theme.sizing.scale600 })}>
              <Button
                kind={KIND.primary}
                isLoading={isLoading}
                onClick={()=> handleConfirmCode(code)}
                overrides={{
                  BaseButton: { style: { width: "100%" } },
                }}
              >
                Confirm
              </Button>
            </div>

          </AuthForm>

  );
}
export default ConfirmationCodeView;
